import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { donationsVerificationKeys } from "./keys.ts";
import { getUnassignedStages } from "../api.ts";
import type {
  DonationsQueryParams,
  UnassignedStagesListResponse,
} from "../../types.ts";

// Query hook for fetching unassigned verification stages
export const useUnassignedStagesQuery = (
  params: DonationsQueryParams | null,
) => {
  return useQuery<UnassignedStagesListResponse>({
    queryKey: donationsVerificationKeys.unassignedStages(
      params as DonationsQueryParams,
    ),
    queryFn: async () => {
      const { data } = await getUnassignedStages(
        params?.page || 1,
        params?.perSize || null,
        params?.search || {
          toTime: "",
          fromTime: "",
          projectIds: [],
          projectAttributeId: "",
          stageName: "",
          smsSendingDateTimeFrom: "",
          smsSendingDateTimeTo: "",
          projectClassificationId: "",
          searchKey: "",
          isFirstStageVerified: "",
        },
      );
      return data;
    },
    enabled: !!params,
    ...reactQueryCacheAndRefetchOptions,
  });
};
